import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Phone } from 'lucide-react';
import { businessInfo } from '../mock';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { path: '/', label: 'Home' },
    { path: '/about', label: 'About' },
    { path: '/services', label: 'Services' },
    { path: '/gallery', label: 'Gallery' },
    { path: '/testimonials', label: 'Testimonials' },
    { path: '/contact', label: 'Contact' }
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header style={{
      background: 'var(--bg-page)',
      borderBottom: '1px solid var(--border-medium)',
      position: 'sticky',
      top: 0,
      zIndex: 100
    }}>
      <div className="container" style={{padding: '20px 40px'}}>
        <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
          {/* Logo */}
          <Link to="/" style={{textDecoration: 'none'}}>
            <div style={{display: 'flex', flexDirection: 'column'}}>
              <h1 className="heading-5" style={{color: 'var(--brand-primary)', marginBottom: '2px', letterSpacing: '0.02em'}}>SBF HOME IMPROVEMENTS</h1>
              <span className="caption" style={{color: 'var(--text-secondary)', fontSize: '0.7rem'}}>PA LICENSE #{businessInfo.license}</span>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <nav style={{display: 'none', '@media (min-width: 768px)': {display: 'flex'}}} className="desktop-nav">
            <div style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className="nav-link"
                  style={{
                    color: isActive(link.path) ? 'var(--brand-primary)' : 'var(--text-primary)',
                    textDecoration: 'none',
                    padding: '12px 16px',
                    borderRadius: '8px',
                    transition: 'all 0.3s ease',
                    fontWeight: isActive(link.path) ? 600 : 500
                  }}
                >
                  {link.label}
                </Link>
              ))}
              <a href={`tel:${businessInfo.phone}`} className="btn-primary" style={{marginLeft: '16px', padding: '12px 20px'}}>
                <Phone size={18} style={{marginRight: '8px'}} />
                CALL NOW
              </a>
            </div>
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            style={{
              background: 'none',
              border: 'none',
              color: 'var(--text-primary)',
              cursor: 'pointer',
              padding: '8px'
            }}
            className="mobile-menu-btn"
          >
            {isMenuOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <nav className="mobile-nav" style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '8px',
            marginTop: '24px',
            paddingTop: '24px',
            borderTop: '1px solid var(--border-medium)'
          }}>
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setIsMenuOpen(false)}
                style={{
                  color: isActive(link.path) ? 'var(--brand-primary)' : 'var(--text-primary)',
                  textDecoration: 'none',
                  padding: '12px 16px',
                  borderRadius: '8px',
                  transition: 'all 0.3s ease',
                  fontWeight: isActive(link.path) ? 600 : 500,
                  background: isActive(link.path) ? 'var(--bg-card)' : 'transparent'
                }}
              >
                {link.label}
              </Link>
            ))}
            <a href={`tel:${businessInfo.phone}`} className="btn-primary" style={{marginTop: '16px', textAlign: 'center'}}>
              <Phone size={18} style={{marginRight: '8px'}} />
              CALL NOW
            </a>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;